import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const verticalsAdapter = getAdapter({ idFieldName: 'id' });

const verticalsSlice = createSlice({
  name: 'verticals',
  initialState: verticalsAdapter.getInitialState(),
  reducers: {
    setVerticals: (state, { payload: { verticals } }) => {
      verticalsAdapter.setAll(state, verticals);
    },
  },
});

const selectors = verticalsAdapter.getSelectors(({ verticals }) => verticals);

export const getVerticals = (state) => selectors.selectAll(state);

export const { setVerticals } = verticalsSlice.actions;
export default verticalsSlice.reducer;
